import { useEffect, useState, useRef } from 'react';
import axios from 'axios';

const API = 'https://ticobaterias.com/api';
const token = () => localStorage.getItem('token');
const headers = () => ({ Authorization: `Bearer ${token()}` });

export default function Emojis() {
  const [emojis, setEmojis] = useState<any[]>([]);
  const [modal, setModal] = useState(false);
  const [editando, setEditando] = useState<any>(null);
  const [form, setForm] = useState({ emoji: '', nombre: '', orden: 0, tamano: 'mediano' });
  const [imagenFile, setImagenFile] = useState<File|null>(null);
  const [imagenPreview, setImagenPreview] = useState('');
  const [confirmId, setConfirmId] = useState<number|null>(null);
  const [cargando, setCargando] = useState(false);
  const [toast, setToast] = useState('');
  const imagenRef = useRef<HTMLInputElement>(null);

  const mostrarToast = (msg: string) => { setToast(msg); setTimeout(() => setToast(''), 3000); };

  const cargar = async () => {
    const r = await fetch(`${API}/emojis/admin`, { headers: headers() });
    setEmojis(await r.json());
  };

  useEffect(() => { cargar(); }, []);

  const abrirNuevo = () => {
    setEditando(null);
    setForm({ emoji: '', nombre: '', orden: 0, tamano: 'mediano' });
    setImagenFile(null);
    setImagenPreview('');
    setModal(true);
  };

  const abrirEditar = (e: any) => {
    setEditando(e);
    setForm({ emoji: e.emoji||'', nombre: e.nombre||'', orden: e.orden||0, tamano: e.tamano||'mediano' });
    setImagenFile(null);
    setImagenPreview(e.imagen_url ? `https://ticobaterias.com${e.imagen_url}` : '');
    setModal(true);
  };

  const seleccionarImagen = (e: any) => {
    const file = e.target.files[0];
    if (file) { setImagenFile(file); setImagenPreview(URL.createObjectURL(file)); }
  };

  const guardar = async () => {
    setCargando(true);
    try {
      let emojiId = editando?.id;
      if (editando) {
        await axios.put(`${API}/emojis/${editando.id}`, form, { headers: headers() });
      } else {
        const res = await axios.post(`${API}/emojis/`, form, { headers: headers() });
        emojiId = res.data.id;
      }
      if (imagenFile && emojiId) {
        const fd = new FormData();
        fd.append('file', imagenFile);
        await axios.post(`${API}/emojis/${emojiId}/imagen`, fd, { headers: { ...headers(), 'Content-Type': 'multipart/form-data' } });
      }
      await cargar();
      setModal(false);
      mostrarToast(editando ? '✅ Ícono actualizado' : '✅ Ícono agregado');
    } catch { mostrarToast('❌ Error al guardar'); }
    setCargando(false);
  };

  const eliminar = async (id: number) => {
    await fetch(`${API}/emojis/${id}`, { method: 'DELETE', headers: headers() });
    setConfirmId(null);
    await cargar();
    mostrarToast('🗑️ Ícono eliminado');
  };

  const tamanoClass = (t: string) => t === 'pequeño' ? 'text-2xl' : t === 'grande' ? 'text-5xl' : 'text-4xl';

  return (
    <div>
      {toast && (
        <div className="fixed top-6 right-6 z-50 bg-white border border-gray-200 shadow-xl rounded-xl px-5 py-3 text-sm font-semibold text-gray-700">{toast}</div>
      )}

      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-2xl font-bold text-azul">Banco de Íconos</h1>
          <p className="text-gray-500 text-sm mt-1">Emojis e imágenes para las categorías</p>
        </div>
        <button onClick={abrirNuevo}
          className="bg-rojo hover:bg-rojo-dark text-white px-5 py-2.5 rounded-xl font-semibold text-sm transition-all">
          + Agregar Ícono
        </button>
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
        {emojis.length === 0 ? (
          <div className="text-center py-16 text-gray-400">
            <div className="text-4xl mb-3">😶</div>
            <div className="font-medium">No hay íconos en el banco</div>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3">
            {emojis.map(e => (
              <div key={e.id} className={`border rounded-xl p-4 text-center transition-all ${e.activo ? 'border-gray-100 hover:border-azul' : 'border-gray-100 opacity-40'}`}>
                <div className="flex items-center justify-center mb-2" style={{minHeight:'56px'}}>
                  {e.imagen_url
                    ? <img src={`https://ticobaterias.com${e.imagen_url}`} alt={e.nombre} className={`object-contain mx-auto ${e.tamano === 'pequeño' ? 'h-8' : e.tamano === 'grande' ? 'h-16' : 'h-12'}`}/>
                    : <span className={tamanoClass(e.tamano||'mediano')}>{e.emoji}</span>
                  }
                </div>
                <div className="text-xs font-medium text-gray-600 truncate">{e.nombre || '—'}</div>
                <div className="text-xs text-gray-400 mb-3">{e.tamano||'mediano'}</div>
                <div className="flex gap-1 justify-center">
                  <button onClick={() => abrirEditar(e)} className="text-azul hover:bg-azul/10 px-2 py-1 rounded text-xs font-bold transition-colors">✏️</button>
                  <button onClick={() => setConfirmId(e.id)} className="text-rojo hover:bg-rojo/10 px-2 py-1 rounded text-xs font-bold transition-colors">🗑️</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Modal confirmar */}
      {confirmId !== null && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6">
            <div className="text-4xl text-center mb-3">🗑️</div>
            <h3 className="text-lg font-bold text-gray-800 text-center mb-2">¿Eliminar ícono?</h3>
            <p className="text-sm text-gray-500 text-center mb-6">Esta acción no se puede deshacer.</p>
            <div className="flex gap-3">
              <button onClick={() => setConfirmId(null)} className="flex-1 px-4 py-2.5 rounded-xl border border-gray-200 text-sm font-medium text-gray-600 hover:bg-gray-50">Cancelar</button>
              <button onClick={() => eliminar(confirmId)} className="flex-1 px-4 py-2.5 rounded-xl bg-rojo hover:bg-rojo-dark text-white text-sm font-semibold">Sí, eliminar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal formulario */}
      {modal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-40 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-gray-100">
              <h2 className="text-lg font-bold text-azul">{editando ? 'Editar Ícono' : 'Nuevo Ícono'}</h2>
            </div>
            <div className="p-6 space-y-4">

              {/* Imagen personalizada */}
              <div>
                <label className="text-sm font-medium text-gray-700 block mb-1">Imagen personalizada (opcional)</label>
                <div onClick={() => imagenRef.current?.click()}
                  className="border-2 border-dashed border-gray-200 rounded-xl p-4 text-center cursor-pointer hover:border-azul transition-colors">
                  {imagenPreview ? (
                    <img src={imagenPreview} alt="" className="h-16 mx-auto object-contain rounded-lg"/>
                  ) : (
                    <div className="py-2">
                      <div className="text-2xl mb-1">🖼️</div>
                      <p className="text-gray-400 text-xs">Clic para subir imagen</p>
                      <p className="text-gray-300 text-xs mt-0.5">PNG, SVG, WEBP recomendado</p>
                    </div>
                  )}
                </div>
                <input ref={imagenRef} type="file" accept="image/*" onChange={seleccionarImagen} className="hidden"/>
              </div>

              {/* Emoji texto */}
              <div>
                <label className="text-sm font-medium text-gray-700 block mb-1">Emoji (si no sube imagen)</label>
                <input value={form.emoji} onChange={e => setForm({...form, emoji: e.target.value})}
                  placeholder="Ej: 🔋"
                  className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-2xl focus:outline-none focus:border-azul text-center" />
                <p className="text-xs text-gray-400 mt-1">Copiá y pegá el emoji directamente</p>
              </div>

              <div>
                <label className="text-sm font-medium text-gray-700 block mb-1">Nombre *</label>
                <input value={form.nombre} onChange={e => setForm({...form, nombre: e.target.value})}
                  placeholder="Ej: Batería"
                  className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-azul" />
              </div>

              <div>
                <label className="text-sm font-medium text-gray-700 block mb-2">Tamaño</label>
                <div className="flex gap-2">
                  {['pequeño','mediano','grande'].map(t => (
                    <button key={t} type="button" onClick={() => setForm({...form, tamano: t})}
                      className={`flex-1 py-2 rounded-xl text-sm font-medium border transition-all ${form.tamano === t ? 'bg-azul text-white border-azul' : 'border-gray-200 text-gray-600 hover:border-azul'}`}>
                      {t === 'pequeño' ? '🔹 Pequeño' : t === 'mediano' ? '🔷 Mediano' : '🔶 Grande'}
                    </button>
                  ))}
                </div>
              </div>

              <div>
                <label className="text-sm font-medium text-gray-700 block mb-1">Orden</label>
                <input type="number" min="0" value={form.orden} onChange={e => setForm({...form, orden: Number(e.target.value)})}
                  className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-azul" />
              </div>
            </div>
            <div className="p-6 border-t border-gray-100 flex gap-3 justify-end">
              <button onClick={() => setModal(false)} className="px-5 py-2.5 rounded-xl border border-gray-200 text-sm font-medium text-gray-600 hover:bg-gray-50">Cancelar</button>
              <button onClick={guardar} disabled={cargando || (!form.emoji && !imagenFile && !imagenPreview)}
                className="px-5 py-2.5 rounded-xl bg-rojo hover:bg-rojo-dark text-white text-sm font-semibold disabled:opacity-50">
                {cargando ? 'Guardando...' : editando ? 'Guardar Cambios' : 'Agregar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
